import type { RoomsParticipantDistribution } from '@/domain/shared/types'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { ParticipantsFilterComponentLegacy } from '@/scopes/search/components/ParticipantsFilterComponentLegacy'
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBarLegacy/store'
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics'
import { formatParticipantDistributionToGA4Result } from '@/scopes/search/search/domain/analytics/mappers'
import { useValueFilter } from '@/scopes/search/search/domain/hooks'
import * as React from 'react'

export function ParticipantsQuickSearchItemFilterLegacy() {
  const { setActiveItem } = useQuickSearchStore()
  const { sendEvent } = useAnalytics()
  const { isFetching, setSelection } = useValueFilter('Participants')

  function handleConfirm(roomsParticipantDistribution: RoomsParticipantDistribution) {
    setActiveItem(null)
    setSelection(roomsParticipantDistribution)
    sendEvent(
      createSearchFilterClickEvent({
        element: 'participants selector',
        type: 'partyComposition',
        result: formatParticipantDistributionToGA4Result(roomsParticipantDistribution).distribution,
      }),
    )
  }

  return <ParticipantsFilterComponentLegacy setSelection={handleConfirm} disabled={isFetching} />
}
